<template>
  <el-card shadow="never" class="chart-card" :class="cardClass">
    <div class="chart-card__header">
      <div>
        <h4 class="chart-card__title">
          <slot name="title">{{ title }}</slot>
          <el-tooltip v-if="tooltip" effect="dark" placement="top">
            <div slot="content" class="chart-card__tooltip-content">{{ tooltip }}</div>
            <em class="el-icon-info"></em>
          </el-tooltip>
        </h4>
        <p class="chart-card__subtitle" v-if="subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <div class="chart-card__body">
      <slot></slot>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "ChartCard",
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      default: ""
    },
    wide: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cardClass() {
      return this.wide ? "chart-card--wide" : "";
    }
  }
};
</script>

<style scoped>
.chart-card {
  margin-bottom: 20px;
}
.chart-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.chart-card__title {
  margin: 0;
  font-size: 15px;
  color: #003448;
  display: flex;
  align-items: center;
  gap: 6px;
}
.chart-card__subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  color: #909399;
}
.chart-card__body {
  margin-top: 14px;
}
.chart-card__tooltip-content {
  max-width: 240px;
}
</style>



// WEBPACK FOOTER //
// src/components/auditLog/ChartCard.vue